import { List, Record } from "immutable";

export type RecentlyStudiedCourseType = {
  courseId?: string;
  studiedDate?: string;
};

const defaultRecentlyStudiedCourseValues: RecentlyStudiedCourseType = {
  courseId: undefined,
  studiedDate: undefined
};

export class RecentlyStudiedCourse extends Record(
  defaultRecentlyStudiedCourseValues
) {}

export type RecentlyStudiedCourses = List<RecentlyStudiedCourse>;

export type UserStatType = {
  sessionsCompleted: number;
  totalStudyTime: number;
  lastStudied: string | null;
  sessionModulesStudied: number;
  sessionModulesCorrect: number;
  recentlyStudiedCourses: RecentlyStudiedCourses;
  numberOfNotesOnlySessions: number;
};

export type UserStatServerType = UserStatType & {
  lastStudied: number;
};

const defaultUserStatValues: UserStatType = {
  sessionsCompleted: 0,
  totalStudyTime: 0,
  lastStudied: null,
  sessionModulesStudied: 0,
  sessionModulesCorrect: 0,
  recentlyStudiedCourses: List(),
  numberOfNotesOnlySessions: 0
};

export default class UserStat extends Record(defaultUserStatValues) {}
